import orgServices from '../../../../services/notisphere/organization'
import UserModal from './UserModal'
import { EMAIL_STATUS } from '../../../../misc/commons'
import store from '../../../../store'
export default {
    name: 'Step1NonVerifiedUser',
    props: {
        organizationId: {
            type: Number,
            required: true
        }
    },
    components: {
        UserModal,
    },
    data() {
        return {
            total: 0,
            delay: 700,
            clicks: 0,
            timer: null,
            items: [],
            searchQuery: {},
            organization_id: this.organizationId,
            organizations: [],
            status: EMAIL_STATUS,
            userModalKey: 0,
            createdEmailTime: null,
            createdEmail: null,
        }
    },
    mounted() {
        if (this._isNotisphere) {
            this.fetchOrgMeta()
        }
    },
    computed: {
        header() {
            var arr = [
                {
                    label: 'Name',
                    name: 'full_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Email',
                    name: 'email',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Organization',
                    name: 'organization_name',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Title',
                    name: 'title',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                },
                {
                    label: 'Phone Number',
                    name: 'phone_number',
                    sort: true,
                    row_text_alignment: 'text-left',
                    column_text_alignment: 'text-left',
                    column_classes: 'customalign-30percent',
                },
                {
                    name: 'action',
                    row_text_alignment: 'text-right',
                    column_text_alignment: 'text-right',
                }
            ]

            if (this._isNotisphere) {
                return arr
            } else {
                if(store.state.userType =='SUPPLIER')
                {
                    return arr.filter(x => {
                        if (!['organization_name', 'organization_type','userSite'].includes(x.name)) {
                            return x
                        }
                    })
                }
                else{
                    return arr.filter(x => {
                        if (!['organization_name', 'organization_type'].includes(x.name)) {
                            return x
                        }
                    })
                }
            }
        },
        currentUserId() {
            return this.$store.state.user.id ? this.$store.state.user.id : -1
        }
    },
    methods: {
        onCompleted(type) {
            if (type.type == 'UPDATE') {
                this._showToast('Updated successfully!')
            }
            if (type.type == 'INSERT') {
                this._showToast('Added successfully!')
            }
            this.createdEmailTime = type.emailTime
            this.createdEmail=type.emailId
            this.fetchData()
        },
        addMoreClick() {
            this.userModalKey += 1
            this.$nextTick(() => {
                this.$refs.userModal.forceRerenderInsert(this.organization_id)
            })
        },
        doubleClick(event){
            this.clicks++
            if(this.clicks === 1) {
                var self = this
                this.timer = setTimeout(function() {
                    self.clicks = 0
                }, this.delay)
            } else{
                clearTimeout(this.timer)
                this.updateUser(event)
                this.clicks = 0
            }
        },
        updateUser(payload, e = null) {
            this.userModalKey += 1
            this.$nextTick(() => {
                this.$refs.userModal.forceRerenderUpdate(payload.id, payload.organization_id,payload.organization_type,payload.status)
            })
            if (e) {
                e.stopPropagation()
            }
        },
        fetchDelay() {
            this.$refs.table.fetchDelay()
        },
        fetchData() {
            orgServices.getNonVerifiedUsers({
                ...this.searchQuery,
                sortField: this.searchQuery.sort[0] ? this.searchQuery.sort[0].name : null,
                sortDirection: this.searchQuery.sort[0] ? this.searchQuery.sort[0].order : null,
                organizationId: this.organization_id
            }).then(resp => {
                if (!resp.error) {
                    this.items = resp.data.d.c
                    this.total = resp.data.d.t
                    for(let i = 0 ; i < this.items.length ; i++)
                    {
                        if(this.createdEmailTime != null)
                        {
                            if(this.createdEmail == this.items[i].email)
                            {
                                this.items[i].email_status_date = this.createdEmailTime
                            }
                        }
                        if(this.items[i].phone_number != null || this.items[i].phone_number != undefined)
                        {
                            var x = this.items[i].phone_number.replace('+1', '').replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
                            this.items[i].phone_number = (x[1] ? x[1] + '-' : '') + x[2] + (x[3] ? '-' + x[3] : '')
                        }
                    }
                }
            })
        },
        fetchOrgMeta() {
            orgServices.findMeta().then(resp => {
                if (!resp.error) {
                    this.organizations = resp.data.d
                }
            })
        },
    }
}